export const darktheme={
    bg:"#181818",
    bgLight:"#202020",
    text:"white",
    textSoft:"#aaaaaa",
    soft:"#373737"
}
export const lighttheme={
    bg:"#f9f9f9",
    bgLight:"white",
    text:"black",
    textSoft:"#606060",
    soft:"#f5f5f5"
}